var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-select", {
    attrs: {
      clearable: false,
      multiple: false,
      options: _vm.yearOptions,
      label: "name",
      name: "year",
      id: "year",
      placeholder: "Pilih Tahun",
      single: true,
    },
    on: { input: _vm.handleYearChange },
    model: {
      value: _vm.selectedYear,
      callback: function ($$v) {
        _vm.selectedYear = $$v
      },
      expression: "selectedYear",
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }